import { ObjectSchema, yup } from '@framework/validation';
import { IMapLayer, MapLayerType, isVectorLayerType } from './MapLayer';

export const MapLayerSchema: ObjectSchema<IMapLayer> = yup
  .object({
    type: yup.string().required().oneOfEnum(MapLayerType).label('Tipo'),
    name: yup.string().required().label('Nome'),
    url: yup.string().required().label('URL'),
    minZoom: yup.number().min(0).positive().integer().label('Zoom Minimo'),
    labelPropertyName: yup.string().notRequired().label('Etichetta Geometria'),
    style: yup
      .object({
        fillColor: yup
          .string()
          .required()
          .label('Colore di riempimento')
          .parentWhen(['^.type'], ([type], schema) =>
            isVectorLayerType(type)
              ? schema.required()
              : schema.notRequired().strip(),
          ),
        strokeColor: yup
          .string()
          .required()
          .label('Colore del bordo')
          .parentWhen(['^.type'], ([type], schema) =>
            isVectorLayerType(type)
              ? schema.required()
              : schema.notRequired().strip(),
          ),
        strokeWidth: yup
          .number()
          .min(0)
          .required()
          .label('Spessore del bordo')
          .parentWhen(['^.type'], ([type], schema) => {
            console.log('type', type, isVectorLayerType(type));
            return isVectorLayerType(type)
              ? schema.required()
              : schema.notRequired().strip();
          }),
        opacity: yup
          .number()
          .min(0)
          .max(1)
          .default(1)
          .required()
          .label('Opacità'),
      })
      .addChildrenParentDeps()
      .required(),
  })
  .noUnknown()
  .required();
